import { render } from "./CustomTab.vue?vue&type=template&id=c772d834&scoped=true"
import script from "./CustomTab.vue?vue&type=script&lang=ts"
export * from "./CustomTab.vue?vue&type=script&lang=ts"

import "./CustomTab.vue?vue&type=style&index=0&id=c772d834&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-c772d834"

export default script